'use strict';

angular.module('mx.SolutionBuilderAgent').component('mxObjectJournal', {
	require: {
		mxFormCtrl: '?^mxForm',
		parentViewController: '?^^mxView',
	},
	bindings: {
		objectId: '@',
		entity: '@',
		itemsPerPage: '<?',
		readOnly: '<?',
		setVisibleInPortal: '<?',
		setSectionNewCommentInBottom: '@',
		hideVisibleInPortal: '<?',
	},
	controller: MxObjectJournalCtrl,
	controllerAs: 'vm',
	template: mxObjectJournalTemplate,
});

MxObjectJournalCtrl.$inject = [
	'$scope',
	'$element',
	'$attrs',
	'$timeout',
	'mx.shell.UserProfileService',
	'mx.SolutionBuilderAgent.JournalService',
	'mx.shell.Config',
	'mx.shell.NotificationService',
	'mx.internationalization',
	'mx.shell.EventService',
	'mx.SolutionBuilderAgent.DialogOpenerService',
	'mx.sb.Attachment.MxAttachmentService',
];

function MxObjectJournalCtrl(
	$scope,
	$element,
	$attrs,
	$timeout,
	userProfileService,
	journalService,
	config,
	notificationService,
	i18n,
	eventService,
	dialogOpener,
	attachmentService
) {
	const vm = this;
	let journalTextboxContainer;

	vm.showObjectDetails = showObjectDetails;
	vm.getJournalData = getJournalData;
	vm.getImageUrl = getImageUrl;
	vm.addJournalComment = addJournalComment;
	vm.updateJournalVisibility = updateJournalVisibility;
	vm.selectFiles = selectFiles;

	vm.$onInit = function () {
		vm.ready = false;
		vm.attachments = [];
		vm.visibleInPortal = config.get('visibleInPortalByDefault') === true || !vm.setVisibleInPortal;

		// For Print-mode we want to print all journal-items
		vm.itemsPerPage = window.location.href.indexOf('/print-details/') === -1 ? vm.itemsPerPage : 10000;
	};

	vm.$postLink = function () {
		if (vm.mxFormCtrl && vm.mxFormCtrl.objectId && vm.objectId === undefined) {
			vm.objectId = vm.mxFormCtrl.objectId;
		}
		if ($attrs.setSectionNewCommentInBottom) {
			$scope.$watch('vm.readOnly', function () {
				if (!vm.readOnly) {
					_relocateJournalTextbox();
				}
			});
		}
	};

	$scope.$watch('vm.objectId', function () {
		if (!vm.profile) {
			userProfileService.get().then(function (profile) {
				vm.profile = profile;
				vm.ready = Boolean(profile) && Boolean(vm.objectId);
			});
		}
	});

	$scope.$on('$destroy', function () {
		if (journalTextboxContainer) {
			journalTextboxContainer.empty();
		}
	});

	return vm;

	function showObjectDetails($event) {
		const targetIsLink = (($event.target || {}).tagName || '').toLowerCase() === 'a';

		if (targetIsLink) {
			const classList = $event.target.classList;

			if (classList && classList.length >= 3) {
				const details = {
					EntityType: $event.target.classList[2],
					Id: $event.target.classList[1],
					DisplayString: $event.target.innerText,
				};

				if (mx.components.Utils.isGuid(details.Id)) {
					eventService.dispatchEvent(mx.SolutionBuilderAgent.Events.ForceOpenObjectDetails, details);
				}
			}
		}
	}

	async function getJournalData(start, count) {
		const allowedInPortal = !vm.setVisibleInPortal;

		try {
			const regex = /"\/SPS\/Forms\/(AttachmentDownload\.aspx|AttachmentHandler\.ashx)?[^"]*FileID=([^&]+)[^"]*"/g;
			const data = (await journalService.get(vm.objectId, allowedInPortal, start, count, '<a href="#" class="mx-object-journal--link {0} {1}">{2}</a>')) || [];
			const files = (await attachmentService.getFilesForObject(vm.objectId)) || [];
			const processedData = await Promise.all(
				data.map(async function (item) {
					async function replaceUrls(text) {
						const matches = Array.from(text.matchAll(regex));
						const replacements = await Promise.all(
							matches.map(async ([fileUrlMatch, , fileId]) => {
								const fileInfo = files.find((file) => file.id === fileId);
								const fileUrl = fileInfo
									? await attachmentService.getFileUrl({
											id: fileId,
											providerId: fileInfo.providerId,
											sendContentThroughServer: fileInfo.sendContentThroughServer,
									  })
									: `api/fileStorage/${fileId}`;
								return { fileUrlMatch, fileUrl };
							})
						);

						let itemText = text;

						replacements.forEach(({ fileUrlMatch, fileUrl }) => {
							itemText = itemText.replace(fileUrlMatch, `"${attachmentService.formatFileUrl(fileUrl)}"`);
						});

						itemText = itemText.replace(
							'<a target="_blank" class="mx-journal-attachment-link"',
							'<md-icon class="material-icons mx-journal-attachment-icon" aria-hidden="true">attachment</md-icon><a target="_blank" class="mx-journal-attachment-link"'
						);
						return itemText;
					}

					const text = await replaceUrls(item.Text);

					return {
						userId: item.CreatorFragmentId,
						userName:
							item.Creator ||
							(item.CreatorFragmentId === '00000000-0000-0000-0000-000000000000' ? i18n.get('solutionBuilderAgent.components.mx-object-journal.system') : ''),
						text: text,
						color: (item.Color || '').replace(/0xff808080/i, '').replace(/^0xff/i, '#'),
						created: item.CreatedDate,
						photo: getImageUrl(item.CreatorPhoto),
						visibleInPortal: item.VisibleInPortal || false,
						entryId: item.Id,
						subject: item.Header,
					};
				})
			);
			return processedData;
		} catch (error) {
			notificationService.error(i18n.get('solutionBuilderAgent.layouts.errors.error_in_journal_data') + error);
			return [];
		}
	}

	function addJournalComment(text, attachments) {
		const journalObject = {
			ObjectId: vm.objectId,
			Comments: text,
			Publish: true,
			EntryType: 0,
			Creator: vm.profile.id,
			FileIds: attachments.map(function (file) {
				return file.Id;
			}),
		};

		if (vm.visibleInPortal) {
			journalObject.VisibleInPortal = true;
		}

		return journalService.add(journalObject);
	}

	function updateJournalVisibility(entryId, visibleInPortal) {
		journalService.update({
			Id: entryId,
			VisibleInPortal: visibleInPortal,
		});
	}

	function getImageUrl(photo) {
		return journalService.img(photo);
	}

	function selectFiles() {
		return dialogOpener.selectFiles(vm.objectId, vm.entity, true, vm.parentViewController && vm.parentViewController.mxView);
	}

	function _relocateJournalTextbox() {
		$timeout(function () {
			// such complex selector because we have `Custom Forms`
			journalTextboxContainer = $element.closest('mx-dialog-container').children('.mx-dialog-content--bottom-container:visible');
			$element.find('mx-journal').addClass('mx-journal-new--at-bottom');
			const journalTextboxForMoving = $element.find('.journal-item--new:visible');
			if (journalTextboxForMoving.length > 0 && journalTextboxContainer.length > 0) {
				journalTextboxContainer.empty();
				$(journalTextboxForMoving).appendTo(journalTextboxContainer);
			}
		});
	}
}

mxObjectJournalTemplate.$inject = ['mx.internationalization', '$attrs'];

function mxObjectJournalTemplate(i18n, $attrs) {
	const supplement = [];

	if ($attrs.setVisibleInPortal && $attrs.setVisibleInPortal === 'true' && $attrs.hideVisibleInPortal !== 'true') {
		const title = i18n.get('solutionBuilderAgent.components.mx-object-journal.visibleInPortal');

		supplement.push({
			key: 'visibleInPortal',
			title: title,
		});
	}
	const showCheckboxesAttr = supplement.length > 0 ? ' show-checkboxes="::' + JSON.stringify(supplement).replace(/"/g, '&quot;') + '" ' : '';

	return (
		'<mx-journal ' +
		'ng-if="vm.ready" ' +
		'ng-aria-disable ' +
		'ng-click="vm.showObjectDetails($event)" ' +
		'on-get-data="vm.getJournalData(start, count)" ' +
		'items-per-page="{{:: vm.itemsPerPage}}" ' +
		'on-get-user-image="vm.getImageUrl(photo)" ' +
		'read-only="vm.readOnly" ' +
		'on-add="vm.addJournalComment(text, attachments)" ' +
		'on-update="vm.updateJournalVisibility(entryId, visibleInPortal)"' +
		showCheckboxesAttr +
		'attach-files-handler="vm.selectFiles()" ' +
		'current-user-id="{{:: vm.profile.id}}" ' +
		'current-user-photo="{{:: vm.profile.avatar}}"> ' +
		'</mx-journal>'
	);
}
